import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Container } from 'reactstrap';

import { TranslationsKeys } from '../../../locales/translations';
import { StudentsRemovalRequestHistory } from './StudentsRemovalRequestHistory/StudentsRemovalRequestHistory';
import { StudentsRemovalRequestStudents } from './StudentsRemovalRequestStudents/StudentsRemovalRequestStudents';
import { TabsHash } from '../../../components/TabsHash';

export function StudentsRemovalRequest() {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST,
  );

  const tabs = useMemo(
    () => [
      {
        key: 'students',
        name: t(`tabs.students`),
        content: (
          <div className="my-3">
            <StudentsRemovalRequestStudents />
          </div>
        ),
      },
      {
        key: 'history',
        name: t(`tabs.history`),
        content: (
          <div className="my-3">
            <StudentsRemovalRequestHistory />
          </div>
        ),
      },
    ],
    [t],
  );

  return (
    <Container fluid>
      <Card className="px-3">
        <TabsHash tabs={tabs} defaultTab="students" />
      </Card>
    </Container>
  );
}
